var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('program-session-item',{attrs:{"session":_vm.session,"is-page":""}}),_vm._v(" "),_c('program-speaker-modal'),_vm._v(" "),_c('program-session-modal'),_vm._v(" "),_c('program-session-register-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }